/**
 * Phase 17.10: what the organization's plan includes. Standard has the core product; Advanced (and the trial)
 * add the features in ADVANCED_FEATURES. The API enforces it — this only shows locks and the upgrade prompt.
 */
import { computed, ref } from 'vue';
import { planHasFeature, type PlanFeature } from '@codot/contracts';
import { useAuthStore } from './auth.store';

/** Set when the API refused a locked action (or a locked control was used): UpgradeHost shows the prompt. */
export const upgradePrompt = ref<PlanFeature | null>(null);

export function usePlan() {
  const auth = useAuthStore();
  const tier = computed(() => auth.activeOrganization?.planTier ?? 'TRIAL');
  const has = (f: PlanFeature) => planHasFeature(tier.value, f);
  /** Run `go` when the plan includes the feature, else show the upgrade prompt. */
  const guard = (f: PlanFeature, go: () => void) => (has(f) ? go() : (upgradePrompt.value = f));
  return { tier, has, guard };
}
